<div id="initial-information" class="initial-information-content">
  <h1>
    {{ 'rspInitialInformationTitle' | translate }}
  </h1>

  @if (internalPrepareAllowed) {
    <div id="addAssessment" class="card panel panel-info">
      <div class="card-header panel-heading">
        {{ 'rspInitialInformationPrepareTitle' | translate }}
      </div>
      <div class="card-body">
        {{ 'rspInitialInformationChoose' | translate }}
        <div class="product-list">
          @for (productData of kbProductList.products; track productData) {
            <div>
              <input
                type="checkbox"
                value="{{ productData.id }}"
                id="{{ productData.id }}"
                (change)="validateProductSelection()"
                (ngModelChange)="productData.checked = $event"
                [disabled]="!isMultipleInsuredPersonsAllowed && productData.notAvailable"
                [ngModelOptions]="{ standalone: true }"
                [ngModel]="productData.checked"
              />
              <label for="{{ productData.id }}">{{ productData.caption }} </label>
              @if (productData.checked) {
                @for (rider of productData.riders; track rider) {
                  <div class="riders">
                    <input
                      type="checkbox"
                      value="{{ rider.id }}"
                      id="{{ rider.id }}"
                      (change)="validateProductSelection()"
                      (ngModelChange)="rider.checked = $event"
                      [disabled]="!isMultipleInsuredPersonsAllowed && rider.notAvailable"
                      [ngModel]="rider.checked"
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <label for="{{ rider.id }}">{{ rider.caption }} </label>
                  </div>
                }
              }
            </div>
          }
        </div>
        @if (isMultipleInsuredPersonsAllowed) {
          <div class="input-group mt-2 insured-person-name">
            <span class="input-group-text" id="insured-person-name-label">{{
              'rspInitialInformationInsuredPersonNameLabel' | translate
            }}</span>
            <input
              type="text"
              id="insured-person-name"
              class="form-control"
              aria-describedby="insured-person-name-label"
              maxlength="100"
              (ngModelChange)="insuredPersonNameInput = $event"
              [ngModel]="insuredPersonNameInput"
            />
          </div>
        }

        <div aria-live="polite">
          @if (!isDisableable && !addAssessmentEnabled) {
            <p class="rsp-invalid-form-feedback invalid-feedback d-block m-0" [innerHTML]="'rspFormInvalid' | translate"></p>
          } @else {
            <p class="rsp-invalid-form-feedback invisible m-0"></p>
          }
        </div>
      </div>
      <div class="card-footer">
        <button
          id="prepare-assessment"
          class="btn btn-success"
          [attr.aria-disabled]="!addAssessmentEnabled"
          [disabled]="!addAssessmentEnabled && isDisableable"
          (click)="prepareAssessment()"
        >
          {{ 'rspInitialInformationPrepare' | translate }}
        </button>
      </div>
    </div>
  }

  @if (userContextService.currentUserContext$ | async; as userContext) {
    @for (assessmentWrapper of userContext?.assessmentWrappers; track assessmentWrapper.id) {
      <div class="risk-assessment-panel card">
        <div class="panel panel-primary" id="assessment-{{ assessmentWrapper.id }}">
          <div class="card-header bg-primary panel-heading">
            @if (assessmentWrapper.insuredPersonFullName) {
              {{ assessmentWrapper.insuredPersonFullName }} -
            }
            {{ 'rspInitialInformationPanelTitle' | translate }}
            {{ assessmentWrapper.state | translate }}
          </div>
          <div class="card-body">
            <p>
              {{
                'rspInitialInformationCreated'
                  | translate
                    : {
                        created: assessmentWrapper.created | date: ('rspDateFormat' | translate),
                      }
              }}
            </p>
            @for (productView of assessmentWrapper.productViews; track productView) {
              <div>
                <div class="list-group-item well product-info">
                  <p>
                    <strong>
                      {{ 'rspInitialInformationProducts' | translate }}
                    </strong>
                    {{ productView.name }}
                  </p>
                  @if (!hideRiders && productView.riders && productView.riders.length) {
                    <p>
                      <strong>
                        {{ 'rspInitialInformationRiders' | translate }}
                      </strong>
                      {{ productView.riders.join(',') }}
                    </p>
                  }
                </div>
              </div>
            }
            <div class="list-group-item well assessment-status">
              @if (!assessmentWrapper.assessmentId) {
                {{ 'rspInitialInformationNotStarted' | translate }}
              }
              @if (assessmentWrapper.assessmentId) {
                {{
                  isAssessed(assessmentWrapper)
                    ? ('rspInitialInformationCompletedStatus'
                      | translate
                        : {
                            lastModified: assessmentWrapper.lastModified | date: ('rspDateFormat' | translate),
                          })
                    : ('rspInitialInformationOngoingStatus'
                      | translate
                        : {
                            lastModified: assessmentWrapper.lastModified | date: ('rspDateFormat' | translate),
                          })
                }}
              }
            </div>
          </div>
          <div class="card-footer">
            @if (!isAssessed(assessmentWrapper) && internalPrepareAllowed) {
              <button
                class="delete-assessment-button btn btn-secondary ms-1"
                (click)="deleteAssessment(assessmentWrapper.id)"
                type="button"
              >
                {{ 'rspButtonDelete' | translate }}
              </button>
            }
            @if (!isAssessed(assessmentWrapper)) {
              <button
                class="start-assessment-button btn btn-primary"
                (click)="starRestartOrInitializeAssessment(assessmentWrapper.id)"
                type="button"
              >
                @if (!assessmentWrapper.assessmentId) {
                  {{ 'rspInitialInformationStart' | translate }}
                }
                @if (assessmentWrapper.assessmentId) {
                  {{ 'rspInitialInformationContinue' | translate }}
                }
              </button>
            }
            @if (isAssessed(assessmentWrapper)) {
              <button class="view-result-button btn btn-primary" (click)="viewResult(assessmentWrapper.id)" type="button">
                {{ 'rspInitialInformationViewResult' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
